<template>
  <div class="agree-wrap">
    <h2 class="ag-title">一起教育科技内容库用户服务协议</h2>
    <div class="ag-content">
      <p>
        <span>
          <strong>一、服务条款的确认和接纳</strong>
        </span>
      </p>
      <ul>
        <li>
          1、一起教育科技内容库（content.17zuoye.com/）及其涉及到的产品、相关软件、网站的所有权和运营权归上海合煦信息科技有限公司（以下又称“我们”或“一起教育科技”）所有，
          一起教育科技享有一起教育科技内容库上一切活动的监督、提示、检查、纠正等权利。
        </li>

        <li>
          2、一起教育科技内容库用户（又称“您”）是指在一起教育科技内容库自行注账号或通过一起教育科技内容库提供的账号自行登录的个人、单位或其他组织。
        </li>
        <li>
          3、您阅读《一起教育科技内容库您服务协议》（简称“服务协议”）并点击"同意"按钮，即表示您与一起教育科技内容库已达成协议，自愿接受本服务协议的所有内容。请您仔细阅读本《服务条款》，其中包含了关于您的法定权利、救济和义务的重要信息。特别是免除或者限制责任的条款、管辖与法律适用条款。限制、免责条款可能以加粗或加下划线的形式提示您注意。
        </li>
        <li>
          4、如果您不同意服务协议的内容，则不能成为一起教育科技内容库的注册用户或不能在已有账号的情况下登录到一起教育科技内容库，也不能获得使用content.17zuoye.com/服务以及成为一起教育科技内容库您的权利。
        </li>
        <li>
          5、关于我们收集和使用您访问和使用一起教育科技内容库的服务所提供的相关个人信息和内容，详见我们的隐私政策。
        </li>
        <li>
          6、您使用一起教育科技内容库的任何服务时，如由第三方提供支付等服务的，您除了遵守本《服务条款》外，还应遵守该第三方及其所提供服务的相关协议。
        </li>
        <li>
          7、您必须至少年满18周岁，具有完全民事行为能力订立具有法律约束力的合同，以访问和使用我们的服务或注册账户。您访问或使用我们的产品或服务，即表示您陈述和保证您已年满18周岁，且具有订立合同的法律行为能力和授权。如果您为公司或其他实体注册账户，您保证您有权在法律上代表并约束该实体，并授予我们本《服务条款》规定的所有准许和许可。
        </li>
        <li>
          8、我们可以将遵守某些条件或要求作为您访问和使用我们的产品、服务或特定功能的条件，例如完成相关备案、身份核实手续等。
        </li>
        <li>
          9、通过互联网核实用户身份存在困难，我们不对任何用户身份和资质的核实承担任何责任。尽管如此，我们可以：（i）要求您提供身份证复印件、企业营业执照副本复印件、网站ICP备案信息等材料或其他信息，或进行有助于核实用户身份或背景的额外检查，（ii）基于第三方数据库或其他来源筛选用户。我们有权审核并决定是否通过您成为我们的用户的申请。
        </li>
        <li>
          10除非我们授权，您不得注册1个以上账户。您不得以让与或其他方式向另一方转让或出借您的账户。您在我们的服务范围内采用的账户名称、用户识别号和其他识别资料，均属于我们的财产，在您的账户不论何故被您或我们终止或撤销后，我们可以取消、取回和重用该等资料。
        </li>
      </ul>
      <p>
        <span>
          <strong>二、您的权利与义务</strong>
        </span>
      </p>
      <ul>
        <li>
          1、您在申请使用一起教育科技内容库提供的网络服务时，须向一起教育科技提供准确的个人资料，如个人资料有任何变动，您须及时更新。
        </li>
        <li>
          2、账号注册成功后，一起教育科技将给予每个您一个您账号及相应的初始密码，您须及时自行修改并设置新密码。
        </li>
        <li>
          3、您需负责：(i) 保管用以进入您的账户和我们的服务的任何密码，(ii)
          承担通过您的账户对我们的服务所做出的一切使用行为。如您发现或怀疑您的账户或密码已经泄露，必须尽快通知我们。除非我们已接获并确认收到您向我们发出关于您的账户/密码被泄露的通知，我们会将所有在我们的服务内对您账户的使用视为由您做出。因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。您可随时修改自己的密码和账户内图标，也可以注销原有账号，并按照一起教育科技的规定重新注册新账号。
        </li>
        <li>
          4、您使用一起教育科技内容库服务时，应注重保护个人资料，并审慎保管个人账号和密码等信息。如因您个人账号、密码等保管不当，被他人恶意盗用等情形导致账号违规使用等后果的，一起教育科技有权决定如何处置该账号，包括但不限于限定账号权限、立即锁定账号等措施。
        </li>
        <li>
          5、为方便您使用我们及其关联公司提供的其他相关服务，您授权我们将您在注册、激活账户或其他使用我们的服务过程中提供、形成的信息传递给其他相关服务提供者，或从其他相关服务提供者处获取您在注册、使用相关服务期间提供、形成的信息。
        </li>
        <li>
          6、您不得使用一起教育科技内容库服务发送或传播敏感信息、违反国家法律制度及相关政策等的信息，包括但不限于下列信息:
          (a) 反对宪法所确定的基本原则的； (b)
          危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； (c) 损害国家荣誉和利益的； (d)
          煽动民族仇恨、民族歧视，破坏民族团结的； (e) 破坏国家宗教政策，宣扬邪教和封建迷信的； (f)
          散布谣言，扰乱社会秩序，破坏社会稳定的； (g)
          散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； (h)
          侮辱或者诽谤他人，侵害他人合法权益的； (i) 含有法律、行政法规禁止的其他内容的。
        </li>
        <li>
          7、一起教育科技将根据您的发言或行为做出独立判断，必要时有权立即终止您的账号服务等。您须对自己的行为承担法律责任。
        </li>
        <li>
          8、您在使用一起教育科技内容库服务时，必须遵循以下原则: (a) 遵守中国有关的法律和法规； (b)
          不得为任何非法目的而使用网络服务系统； (c) 遵守所有与网络服务有关的网络协议、规定和程序；
          (d)
          不得利用一起教育科技内容库任何服务、系统或您账号等进行任何可能对互联网的正常运转造成不利影响的行为；
          (e)
          不得利用一起教育科技内容库任何服务、系统或您账号等传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；
          (f)
          不得利用一起教育科技内容库任何服务、系统或您账号等进行任何损害一起教育科技利益、权益的行为，包括但不限于不得与他人共享账号、将一起教育科技的试题资源复制发布、编辑出版、转卖或提供给任何第三方组织或个人，不得将一起教育科技的试题资源私自上传到除一起教育科技内容库之外的其他网站、社区、论坛，不得利用您账号或采用技术手段进行高频次的访问、抓取（下载）页面内容，不得进行其他非正常使用的行为等。
        </li>
        <li>
          9、盗取他人您账号或利用网络通讯骚扰他人，均属于非法行为。您不得采用测试、欺骗等任何非法手段，盗取其他您的账号和对他人进行骚扰。
        </li>
        <li>
          10、所有通过我们服务提供的服务、软件（包括任何日后的更新、升级和新版本）以及在服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归我们或我们的授权方所有。除非本条款另行明确规定，否则您无权使用我们的知识产权。特别是，未经我们事先书面同意，您无权使用我们的商标、产品名称（例如一起、一起教育科技等）、企业名称、域名或其他商业标识及智力成果。您向我们提供任何有关我们服务的意见、建议或评价均为自愿，我们有权自行使用该等意见、建议和评价，且无需向您支付任何费用或对您承担任何责任。
        </li>
        <li>
          11、如我们的服务需要您下载并使用我们提供的任何软件，我们根据本条款（包括
          该软件涉及的单独协议或业务规则）赋予您有限、个人、非独家、不可转授、不可转让、可撤销的软件使用权，以便您使用我们的服务。除非您已事先获得我们的书面同意，否则您不得对我们的软件进行复制、修改、反向编译、反向汇编、尝试抽取源代码或进行任何衍生创作。您对任何我们的软件的使用可能还受到其他单独协议的限制。
        </li>
        <li>
          12、当您使用我们的服务或通过我们的服务而提交、上传、发布、产生、传送或显示的任何数据、资料、信息、语音、图像、媒体、作品、链接、回复或其他内容（“您的内容”）时，您同意并知悉：
          （1）我们在全世界范围内享有免费的、永久的、不可撤销的、非排他性的使用和再许可的权利，包括但不限于修改、复制、发行、表演、展览、信息网络传播、改编、翻译、汇编等权利。
          （2）我们可使用您用以提交您的内容的名称（包括您的账户名称、真实名称或其他名称）和您上传到一起练习上的肖像或含有您肖像的摄影作品以及个人信息。
          （3）无偿授权我们和我们的关联公司使用您的内容，包括以您的内容制作汇编作品、衍生作品、公开展示、表演您的内容，作为提供、宣传、推广、提升我们的服务之用。
        </li>
        <li>
          13、您同意保障和维护一起教育科技全体成员的利益，负责支付由您违反本服务条款或为纠正您的违反行为所引起的律师费用、诉讼费用、公证费用、鉴定费用、执行费用等，以及因违反服务条款而引起损害赔偿费用，其他人使用您的电脑、账号和其它知识产权的追索费。如您的密码、账号被盗用，您应承担被盗用期间产生的一切责任和后果；该事件由于一起教育科技的过失导致的除外。
        </li>
        <li>
          14、您使用互联网必须遵守国家有关的政策和法律，包括《中华人民共和国刑法》、《中华人民共和国保守国家秘密法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》等有关计算机及互联网规定的法律和法规、实施办法及相关政策等。保护国家利益，保护国家安全，对于违法使用互联网络而引起的一切责任，由您负全部责任。
        </li>
        <li>
          15、如您的行为使我们或我们的关联公司遭受损失，或遭受任何第三方的权利主张或索赔等，您应当赔偿我们的全部损失；我们有权在对第三人承担金钱给付等义务后就全部损失向您追偿。
        </li>
      </ul>
      <p>
        <span>
          <strong>三、一起教育科技的权利和义务</strong>
        </span>
      </p>
      <ul>
        <li>
          1、一起教育科技有义务在现有技术水平的基础上努力确保网站服务的正常运行，尽力避免服务中断或将中断时间限制在最短时间内，保证您顺利使用一起教育科技服务。
        </li>
        <li>
          2、一起教育科技可能随时修改本服务条款，故请时常返回本页面查阅。我们可能不时增加、变更或完全终止我们的服务项目。若我们认为对本服务条款或我们的服务进行了合理而重大的修改，我们将在修改生效前通过我们的App、软件或者通过其他方式通知您。就服务条款或我们的服务的任何修改，无论我们是否发出通知，如果您继续使用我们的服务，即表示同意受修订后本条款约束。
        </li>
        <li>
          3、您若反对任何服务条款的建议或对后来的条款修改有异议，或对一起教育科技服务不满，您可以终止使用一起教育科技及（或）一起教育科技内容库的服务。终止您服务后，您使用一起教育科技服务的权利也相应终止。同时，一起教育科技不再对您承担任何义务。
        </li>
        <li>
          4、鉴于一起教育科技属于网络服务提供者，一起教育科技对您上传的资源不负事先审查的义务，任何单位或个人认为一起教育科技内容涉嫌侵犯其著作权等权益的，应当及时向我们提交证明权属的相关证据材料，一起教育科技在收到文件后进行审查，并采取适当措施处理。
        </li>
        <li>
          5、一起教育科技不对您所发布信息的删除或储存失败等情形负责。一起教育科技保留判定您的行为是否符合本服务协议要求和精神的权利，如果您违背了本服务协议的约定，则一起教育科技有权中止、中断或终止您的账号及相关服务。
        </li>
        <li>
          6、一起教育科技运用自己的软件或系统通过互联网络为您提供各项服务，您自行负责解决上网所需的各项条件并自行承担相关费用。
        </li>
        <li>
          7、如果您提供的资料不准确，不真实，不合法等，一起教育科技保留在发现后终止您使用一起教育科技各项服务的权利。您同意在使用网站期间，接受一起教育科技提供的各类信息服务，一起教育科技保留对一起教育科技内容库您投放商业性广告的权利。
        </li>
        <li>
          8、如果您违反本服务协议约定，或发生对网站的正常运行、网站内容安全和其他您正常使用等造成不利影响的情况，一起教育科技有权采取包括中止账号使用、限制账号权限、终止您账号、终止提供服务及其他必要的措施，以维护一起教育科技和其他您的合法权益。此种情形下，您已支付的费用不予退还，且一起教育科技保留通过法律手段追究违规您相关责任的权利。
        </li>
      </ul>
      <p>
        <span>
          <strong>四、知识产权</strong>
        </span>
      </p>
      <ul>
        <li>
          1、一起教育科技提供的服务中包含的任何文本、图片、图形、音频和/或视频资料等均受版权、商标和/或其它财产所有权等方面法律的保护,未经相关权利人同意,上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行,或者被用于其他任何商业目的。对所有以上资料或资料的任何部分，任何其他第三方的个人或机构都不得通过任何形式（包括但不限于通过任何机器人、蜘蛛等程序或设备）进行抓取、监视、分发等行为。如您违反前述约定，一起教育科技有权采取包括中止账号使用、限制账号权限、终止您账号、终止提供服务及其他必要的措施，以保护一起教育科技和其他您的合法权益，您已支付的费用不予退还，且一起教育科技保留通过法律手段追究违规您相关责任的权利。
        </li>
        <li>
          2、未经一起教育科技书面同意，您不得利用一起教育科技各项服务在一起教育科技内容库、相关网站或其他媒介上进行发布、销售或其他商业性行为，不得擅自复制、修改、传播、编撰这些内容或为他人提供条件进行上述行为，或创造与内容有关的衍生产品。如您违反前述约定，一起教育科技有权采取包括中止账号使用、限制账号权限、终止您账号、终止提供服务及其他必要的措施，以保护一起教育科技和其他您的合法权益，您已支付的费用不予退还，且一起教育科技保留通过法律手段追究违规您相关责任的权利。
        </li>
        <li>
          3、您保证和声明对您所提供的作品等内容拥有完整的合法著作权等权益，或拥有完整的合法授权，且有权将该等内容用于在一起教育科技内容库上从事的活动，并保证一起教育科技使用该作品不违反国家的法律法规及相关政策，也不侵犯任何第三方的合法权益或承担任何义务。您应对您所提供作品因形式、内容及授权等的不完善、不合法所造成的一切后果承担完全责任。
        </li>
        <li>
          4、对于经您本人创作并上传到一起教育科技内容库的文本、图片、图形、音频和/或视频等，一起教育科技保留对其产品、软件、网站等所有内容进行实时监控的权利，并有权依其独立判断对任何违反本协议约定的作品采取删除、屏蔽等措施。一起教育科技对于删除您作品引起的任何后果或导致您的任何损失不负任何责任。如因您的作品违法或侵害第三人合法权益等情形而导致一起教育科技或其关联公司对第三方承担任何性质的赔偿、补偿、罚款等损失（直接的、间接的、偶然的、惩罚性的损失），您对于一起教育科技或其关联公司蒙受的上述损失承担全部的赔偿责任。
        </li>
      </ul>
      <p>
        <span>
          <strong>五、保密条款</strong>
        </span>
      </p>
      <ul>
        <li>
          1、尊重您的个人隐私是一起教育科技的一项基本政策。一起教育科技会尽最大努力使用相关安全技术和程序，建立完善的管理制度以保护您的个人信息免遭受泄露；一起教育科技不会在未经您明示授权时透露您的注册资料，除非：
          （1）相关法律法规或国家机关要求； （2）一起教育科技发生相关合并、分立、收购或资产转移；
          （3）为提供相关服务所必须的；
          （4）一起教育科技可能会与第三方合作向您提供相关的网络服务，在此情况下，如该第三方同意承担与一起教育科技同等的保护您隐私的责任，则一起教育科技有权将您的注册资料等提供给该第三方。
          对于您所提交的注册信息中涉及个人信息的内容，我们将严格按照《用户隐私保护政策》的规定进行收集、处理和使用。
          （5）其他一起教育科技认为有必要的情况。
        </li>
        <li>
          2、一起教育科技内容库可能会与第三方合作向您提供相关的网络服务，在此情况下，如该第三方同意承担与一起教育科技内容库同等的保护您隐私的责任，则一起教育科技内容库有权将您的注册资料等提供给该第三方。
        </li>
        <li>
          3、在不透露单个用户隐私资料的前提下，一起教育科技内容库有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
        </li>
      </ul>
      <p>
        <span>
          <strong>六、免责条款</strong>
        </span>
      </p>
      <ul>
        <li>
          1、您对您通过一起教育科技内容库服务进行的行为及后果承担风险。在任何情况下，一起教育科技不就因使用或不能使用一起教育科技内容库服务所发生的特殊的、意外的、直接或间接的损失承担赔偿责任。
        </li>
        <li>
          2、您理解并同意，使用一起教育科技内容库提供的服务涉及到Internet服务和电信增值服务，可能会受到各个环节不稳定因素的影响，因此服务可能存在因不可抗力、计算机病毒或黑客攻击、国家相关行业主管部门及电信运营商的调整、系统不稳定、您所在位置、您关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足您要求的风险。您须承担以上风险，一起教育科技不作担保且不承担该等风险的责任。对因此导致您不能发送、上传和接受阅读消息、或接发错消息，或无法实现其他通讯条件等情形的，一起教育科技不承担任何责任。
        </li>
        <li>
          3、您理解并同意，我们的所有服务和软件均为按原状而提供。我们将尽最大努力向您提供服务，确保服务的连贯性和安全性；但我们均没有对我们的服务、软件或任何通过我们的服务提交、提供或显示的内容做出任何声明、保证或给予任何承诺，包括：
          (i) 我们的服务或软件将不受干扰，是安全、没有错漏或没有病毒的；(ii)
          我们的服务或软件将会与您的设备兼容；或 (iii)
          我们的服务或软件将具适销质量、适合特定用途或没有侵犯任何人的知识产权的任何声明、保证或承诺。
        </li>
        <li>
          4、您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使服务中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。如出现上述情况，我们将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失我们在法律允许的范围内免责。
        </li>
        <li>
          5、在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任： (i)
          受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏； (ii)
          您的或我们的电脑软件、系统、硬件和通信线路出现故障； (iii) 您操作不当； (iv)
          您通过非一起教育科技授权的方式使用本服务； (v) 其他一起教育科技无法控制或合理预见的情形。
        </li>
        <li>
          6、您理解并同意，在使用一起教育科技内容库提供的服务中，可能存在有来自任何他人的，包括威胁性的、诽谤性的、令人反感的或非法的内容或行为，或侵犯他人权益（包括但不限于知识产权等权益）的匿名或冒名信息的风险，您须承担该等风险。对因此导致的任何您的直接、间接、偶然的损害等，一起教育科技不承担任何责任。
        </li>
        <li>
          7、一起教育科技不保证网络服务一定能满足您的要求，不保证网络服务不会中断，不保证网络服务的及时性、安全性、准确性。
        </li>
        <li>
          8、若一起教育科技已经明示其网络服务提供方式发生变更，并提醒您应当注意事项，但您未按要求操作的，所产生的一切后果由您自行承担。
        </li>
        <li>
          9、您同意保障和维护一起教育科技及其他用户的利益。由于您登录或上传、传播至一起教育科技的产品、软件、网站等的内容违法、不真实、不正当、侵犯第三方合法权益等，或您违反本协议项下的任何条款而给一起教育科技或任何第三人造成损失的，由您承担由此造成的损害赔偿责任。
        </li>
        <li>
          10、一起教育科技提供与第三方网站的链接。此第三方网站的内容不在我们的控制范围内，我们无法对该等网站中的信息或内容承担责任。我们对该等第三方网站的链接，既不构成对该网站或网站中宣传、提供、销售产品的认可，也不能确保该等网站免受计算机病毒或其它任何具有破坏性的事物的侵害。我们无法对从第三方网站上收集并使用个人信息的行为承担责任。另外，我们不对第三方广告等内容承担责任。
        </li>
        <li>
          11、一起教育科技展示的第三方网站资源内容，是根据您在第三方网站拥有的合法权益和权限来展示的，默认您对此知情和认可，一起教育科技不承担相关责任。
        </li>
        <li>
          12、一起教育科技对您或任何第三方遭受的直接、间接、偶然等损害不承担责任，这些损害来自:不正当使用产品服务，在网上购买商品或类似服务，在网上进行交易，非法使用服务或您传送的信息有所变动等等。您的上述行为引起对一起教育科技或第三方的损害，应当依法承担责任并向一起教育科技进行赔偿，一起教育科技可以自行或协助第三方使用您提供的任何信息进行维权。
        </li>
      </ul>
      <p>
        <span>
          <strong>七、其他</strong>
        </span>
      </p>
      <ul>
        <li>
          1、您理解并同意，有关本协议以及使用我们的服务产生的争议，首先由双方友好协商解决；协商不成的，任何一方可向北京市朝阳区有管辖权的人民法院提起诉讼。
        </li>
        <li>
          2、您在使用一起教育科技的服务时，我们可能会根据所提供的服务内容之特性，制定单独的协议、相关业务规则等（以下合称“单独协议”）。您对前述任何规则、单独协议的接受，视为您对本协议的全部接受；如前述任何单独协议等与本服务条款不一致的，以单独协议为准。
        </li>
        <li>
          3、本服务协议中，任何条款无论因何种原因完全或部分无效或不具有执行力，其余条款仍应有效并有约束力。
        </li>
        <li>
          4、本协议的成立、生效、履行、解释及争议解决，适用中华人民共和国大陆地区法律（不包括冲突法）法规。
        </li>
        <li>
          5、如果您对本协议或本服务有意见或建议，或者希望举报侵权、不良信息等，可与我们的客户服务部门联系。
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'agreecontent',
  data() {
    return {}
  },
  methods: {},
  mounted() {}
}
</script>
<style lang="scss">
.agree-wrap {
  ul li {
    list-style: none;
    padding: 10px 0px;
    line-height: 25px;
    letter-spacing: 2px;
  }
  padding: 5% 10%;
  .ag-title {
    padding: 0px 0px 20px;
    text-align: center;
  }
}
</style>
